export class PointSmart {
    id: string;
    codigoAeroplanta: string;
    alias: string;
    nroPoint: string;
    activo: boolean;
    _modificado: boolean;
}